import { SVGProps } from 'react'

export const NoResultsIconEmail = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="377" height="163" viewBox="0 0 377 163" fill="none" {...props}>
      <g filter="url(#filter0_d_877_125316)">
        <rect x="63.5" y="72.5" width="250" height="51.5759" rx="8" fill="white" />
        <rect x="64" y="73" width="249" height="50.5759" rx="7.5" stroke="#C0C9CE" />
      </g>
      <path
        d="M288.153 91.7563C288.553 90.9247 289.737 90.9247 290.136 91.7563L291.374 94.3321C291.534 94.6659 291.852 94.8966 292.219 94.9459L295.051 95.3269C295.965 95.4498 296.331 96.5759 295.664 97.2128L293.596 99.1857C293.328 99.4413 293.207 99.8146 293.274 100.179L293.786 102.99C293.952 103.898 292.994 104.594 292.182 104.156L289.667 102.799C289.341 102.623 288.949 102.623 288.623 102.799L286.107 104.156C285.296 104.594 284.338 103.898 284.503 102.99L285.016 100.179C285.083 99.8146 284.961 99.4413 284.693 99.1857L282.626 97.2128C281.959 96.5759 282.325 95.4498 283.239 95.3269L286.071 94.9459C286.438 94.8966 286.755 94.6659 286.916 94.3321L288.153 91.7563Z"
        fill="#E9EEF1"
      />
      <circle cx="90.7206" cy="98.2881" r="15.043" fill="#E9EEF1" />
      <rect x="114.36" y="83.2451" width="41.5473" height="8.59599" rx="4" fill="#E9EEF1" />
      <rect x="114.36" y="98.2881" width="132.521" height="5.73066" rx="2.86533" fill="#F2F5F7" />
      <rect x="114.36" y="107.6" width="102.436" height="5.73066" rx="2.86533" fill="#F2F5F7" />
      <g filter="url(#filter1_d_877_125316)">
        <rect x="47.2085" y="50.2021" width="282.583" height="58.298" rx="8" fill="white" />
        <rect x="47.7085" y="50.7021" width="281.583" height="57.298" rx="7.5" stroke="#C0C9CE" />
      </g>
      <path
        d="M301.271 71.6987C301.67 70.8671 302.854 70.8671 303.254 71.6987L304.815 74.9489C304.976 75.2827 305.293 75.5134 305.66 75.5627L309.234 76.0434C310.148 76.1663 310.514 77.2924 309.847 77.9293L307.238 80.4187C306.97 80.6744 306.849 81.0477 306.915 81.412L307.562 84.9592C307.728 85.8668 306.77 86.5628 305.958 86.1248L302.784 84.4132C302.459 84.2374 302.066 84.2374 301.74 84.4132L298.566 86.1248C297.754 86.5628 296.797 85.8668 296.962 84.9592L297.609 81.412C297.676 81.0477 297.555 80.6744 297.287 80.4187L294.678 77.9293C294.011 77.2924 294.376 76.1663 295.291 76.0434L298.864 75.5627C299.231 75.5134 299.549 75.2827 299.709 74.9489L301.271 71.6987Z"
        fill="#E9EEF1"
      />
      <circle cx="77.9766" cy="79.3512" r="17.0036" fill="#E9EEF1" />
      <rect x="104.697" y="62.3477" width="46.9622" height="9.71633" rx="4" fill="#E9EEF1" />
      <rect x="104.697" y="79.3516" width="149.793" height="6.47755" rx="3.23878" fill="#F2F5F7" />
      <rect x="104.697" y="89.876" width="115.786" height="6.47755" rx="3.23878" fill="#F2F5F7" />
      <g filter="url(#filter2_d_877_125316)">
        <rect x="32.6646" y="26.2012" width="311.671" height="64.2989" rx="8" fill="white" />
        <rect x="33.1646" y="26.7012" width="310.671" height="63.2989" rx="7.5" stroke="#C0C9CE" />
      </g>
      <circle cx="66.5997" cy="58.3505" r="18.7538" fill="#E9EEF1" />
      <rect x="96.0706" y="39.5967" width="51.7963" height="10.7165" rx="4" fill="#E9EEF1" />
      <rect x="96.0706" y="58.3516" width="165.212" height="7.14432" rx="3.57216" fill="#F2F5F7" />
      <rect x="96.0706" y="69.959" width="127.705" height="7.14432" rx="3.57216" fill="#F2F5F7" />
      <defs>
        <filter
          id="filter0_d_877_125316"
          x="31.5"
          y="46.5"
          width="314"
          height="115.576"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_877_125316" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_877_125316"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_877_125316"
          x="15.2085"
          y="24.2021"
          width="346.583"
          height="122.298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_877_125316" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_877_125316"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_877_125316"
          x="0.664551"
          y="0.201172"
          width="375.671"
          height="128.299"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_877_125316" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_877_125316"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
